<template>
  <div>
    <div class="chat_model" @touchmove.prevent v-if="dialogFormVisible">
      <div class="chat_container">
        <div class="chat_header">
          <div class="header_left">
            <img class="header_avatar" :src="avatar || defaultAvatar" />
            <div class="header_name">{{ name }}</div>
          </div>
          <div class="header_right"></div>
        </div>
        <el-scrollbar ref="scrollBar" class="chat_content">
          <div v-for="(item, index) in list" :key="index">
            <div class="word" v-if="item.basic.direction === 1">
              <img
                :src="avatar || defaultAvatar"
              />
              <div class="info">
                <p class="time">
                  {{ name }}<span style="margin-left:8px;">{{ moment(item.created).format('YYYY-MM-DD HH:mm:ss') }}</span>
                </p>
                <div class="info-content">
                  {{ item.basic && item.basic.text }}
                </div>
              </div>
            </div>
            <div class="word-my" v-else>
              <div class="info">
                <p class="time">
                  <span style="margin-right: 8px;">{{ moment(item.created).format('YYYY-MM-DD HH:mm:ss') }}</span>{{ (item.people && item.people.name) || '官方客服' }}
                </p>
                <div class="info-content">
                  {{ item.basic && item.basic.text }}
                </div>
              </div>
              <img
                :src="(item.people && item.people.avatar) || defaultAvatar"
              />
            </div>
          </div>
          <div class="chat_new" v-if="isShowNewMessage" @click="scrollToBottom">
            <vab-icon icon="chat-1-line" style="font-size: 15px;" />
            <span>新消息</span>
          </div>
        </el-scrollbar>

        <div class="chat_footer">
          <div class="footer_bottom">
            <div class="footer_btn">
              <el-button @click="close">关闭</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { getMessageList, replyMessage } from '@/api/chat'
  import defaultAvatar from '@/assets/defaultAvatar.png'
  export default {
    name: 'ChatHistoryDetail',
    emits: ['fetch-data'],
    data() {
      return {
        defaultAvatar,
        moment,
        name: '',
        avatar: '',
        text: '',
        list: [],
        dialogFormVisible: false,
        isShowNewMessage: false,
        page: 1,
        size: 10,
        total: 0,
        contextId: '',
        lastScrollTop: '',
      }
    },
    methods: {
      async showEdit(row) {
        this.name = row && row.basic && row.basic.name
        this.avatar = row && row.basic && row.basic.avatar
        this.page = 1
        this.text = ''
        const result = await getMessageList({
          page: 1,
          size: this.size,
          contextId: row.contextId,
        })
        this.list = result && result.list.reverse() || []
        this.total = result && result.total || 0
        this.contextId = row.contextId
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.handleScroll()
          this.initTimer()
        })
      },
      initTimer() {
        this.timer = setInterval(async () => {
          const res = await getMessageList({
            page: 1,
            size: this.size,
            contextId: this.contextId,
          })
          const total = res && res.total || 0
          const scroll = this.$refs['scrollBar'].wrap
          if (total > this.total && scroll.scrollTop !== (scroll.scrollHeight - 50)) {
            this.isShowNewMessage = true
          } else {
            this.list = res && res.list.reverse() || []
            this.total = total
          }
        }, 2000)
      },
      close() {
        if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
        this.dialogFormVisible = false
      },
      handleScroll () {
        const scrollBar = this.$refs['scrollBar'].wrap
        scrollBar.scrollTop = scrollBar.scrollHeight
        scrollBar.addEventListener('scroll', this.listenScroll)
          // console.log('top',scrollBar.scrollHeight)
      },
      async scrollToBottom () {
        const res = await getMessageList({
          page: 1,
          size: this.size,
          contextId: this.contextId,
        })
        this.list = res && res.list.reverse() || []
        this.total = res && res.total || 0
        this.isShowNewMessage = false
        const scrollBar = this.$refs['scrollBar'].wrap
        scrollBar.scrollTop = scrollBar.scrollHeight
      },
      listenScroll () {
        const scrollBar = this.$refs['scrollBar'].wrap
        // console.log('page ', scrollBar.scrollTop)
        if (scrollBar.scrollTop <= 30 && (this.page * this.size < this.total)) {
          this.page += 1
          // console.log('scrollTop ----------',scrollBar.scrollTop,scrollBar.scrollHeight)
          this.lastScrollTop = scrollBar.scrollTop
          this.loadMore()
        }
        // console.log('scrollTop ----------',scrollBar ,scrollBar.scrollTop,scrollBar.scrollHeight)
        // if (scrollBar.scrollTop >= (scrollBar.scrollHeight - 50)) {
        //   this.isShowNewMessage = false
        // }
      },
      async loadMore () {
        const result = await getMessageList({
          page: this.page,
          size: this.size,
          contextId: this.contextId
        })
        const list = result && result.list.reverse() || []
        this.list = list.concat(this.list)
        this.$refs['scrollBar'].wrap.scrollTop = this.lastScrollTop
      },

      async handleReply() {
        if (!this.text) {
          this.$message.error('回复内容不能为空')
          return
        }
        const result = await replyMessage({
          contextId: this.contextId,
          text: this.text
        })
        this.text = ''
        if (result) {
          const res = await getMessageList({
            page: 1,
            size: this.size,
            contextId: this.contextId,
          })
          this.list = res && res.list.reverse() || []
          this.total = res && res.total || 0
          const scrollBar = this.$refs['scrollBar'].wrap
          scrollBar.scrollTop = scrollBar.scrollHeight
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .chat_model {
    // width: 100vw;
    // height: 100vh;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    border: 1px solid #d9d9d9;
    background: rgba($color: #000000, $alpha: 0.6);
    z-index: 100;

    .chat_container {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 600px;
      padding-bottom: 10px;
      background: #fff;
      border-radius: 6px;
      overflow: hidden;

      .chat_header {
        padding-left: 20px;
        padding-right: 80px;
        height: 80px;
        display: flex;
        justify-content: space-between;
        background: rgba(245, 245, 245, 0.7);

        .header_left {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .header_avatar {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            overflow: hidden;
          }

          .header_name {
            margin-left: 10px;
          }
        }
      }

      .chat_footer {
        // border-top: 1px solid #d9d9d9;
        // padding-top: 10px;
        .bottom_content {
          padding: 0 10px;
        }
        .footer_bottom {
          padding: 10px 20px 0;
          height: 50px;
          display: flex;
          justify-content: flex-end;

          .footer_btn {
            height: 40px;
          }
        }
      }
    }
  }
  .chat_content {
    width: 100%;
    height: 400px!important;
    padding: 10px 15px;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;

    .chat_new {
      cursor: pointer;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 20px;
      width: 100px;
      height: 30px;
      border-radius: 20px;
      background: #fff;
      box-shadow: 0 2.5px 10px 0 rgb(31 35 41 / 10%);
      color: #1f2329;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
    }
    .word {
      display: flex;
      margin-bottom: 20px;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
      .info {
        margin-left: 10px;
        .time {
          font-size: 12px;
          color: #999;
          margin: 0;
          height: 20px;
          line-height: 20px;
        }
        .info-content {
          float: left;
          border-radius: 3px;
          padding: 10px;
          font-size: 14px;
          color: #333;
          background: #e2e2e2;
          position: relative;
          margin-top: 8px;
        }
        //小三角形
        .info-content::before {
          position: absolute;
          left: -8px;
          top: 8px;
          content: '';
          border-right: 10px solid #e2e2e2;
          border-top: 8px solid transparent;
          border-bottom: 8px solid transparent;
        }
      }
    }

    .word-my {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 20px;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
      .info {
        width: 90%;
        margin-left: 10px;
        text-align: right;
        .time {
          font-size: 12px;
          color: #999;
          margin: 0;
          height: 20px;
          line-height: 20px;
          margin-right: 10px;
        }
        .info-content {
          color: #fff;
          max-width: 70%;
          padding: 10px;
          font-size: 14px;
          float: right;
          margin-right: 10px;
          position: relative;
          margin-top: 8px;
          background: #5fb878;
          border-radius: 3px;
          text-align: left;
        }
        //小三角形
        .info-content::after {
          position: absolute;
          right: -8px;
          top: 8px;
          content: '';
          border-left: 10px solid #5fb878;
          border-top: 8px solid transparent;
          border-bottom: 8px solid transparent;
        }
      }
    }
  }
</style>
